import React from 'react'

const RSVOverallPerformance = () => {
  return (
    <div id='website-responsive'  style={{ overflow:'hidden'}} >
        <div className='py-md-5 py-4 left-padding10rem1 right-padding10rem1' style={{ padding:'', }} >
        <div className='py- left-padding10rem right-padding10rem' style={{ padding:'', }} >
            <center>
                <div className='bg-ss-secondary rounded10 py-md-4 py-3 px-md-0 px-2' style={{ boxShadow:'5px 3px 12px 0 rgba(0,0,0,.5)' }}>
                    <div className='fs-ss-22-3 text-white text-montserrat fw-600 pb-1'>
                        Overall Performance: 97.1% sensitivity, 99.3% specificity¹
                    </div>
                    <div className='fs-ss-22-3 text-white text-montserrat  fw-600'>
                        SARS-CoV-2 Performance: 98.4% PPA, 98.9% NPA²
                    </div>
                </div>
            </center>
        </div>
        </div>
    </div>
  )
}

export default RSVOverallPerformance